import { t } from '~/i18n';
import { BillingRow, RECEIVER_GROUP, receiverCount } from './useBillingBreakdown';
import { deviceTypeLabel, profileGroup, profileTypeLabel, rowTypeLabel } from './billingLabels';

const escapeCsv = (value: string | number): string => {
  const text = String(value);
  return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

// Build a CSV mirroring the table: Type, Name, seat columns, profile columns, device
// columns, third-party add-on. An empty maximum means no limit is set, which is not the same as zero.
export function buildBillingCsv(
  rows: BillingRow[],
  deviceTypes: string[],
  profileTypes: string[],
  showSeats: boolean,
  showThirdParty: boolean
): string {
  const header = [
    t('billing.table.type'),
    t('billing.table.name'),
    ...(showSeats ? [t('billing.seats.limit')] : []),
    ...profileTypes.map(profileTypeLabel),
    ...deviceTypes.map(deviceTypeLabel),
    ...(showThirdParty ? [t('billing.table.thirdPartyDevices')] : []),
  ];

  const lines = rows.map((row) => {
    const profileCount = (group: string) =>
      row.usage.profiles.items
        .filter((item) => profileGroup(item.profileType) === group)
        .reduce((sum, item) => sum + item.count, 0);
    const deviceCount = (type: string) => row.usage.devices.items.find((item) => item.deviceType === type)?.count ?? 0;
    return [
      rowTypeLabel(row.kind),
      row.name,
      ...(showSeats ? [row.usage.maxConcurrentAlarmReceivers ?? ''] : []),
      ...profileTypes.map((type) =>
        type === RECEIVER_GROUP ? receiverCount(row, profileCount(type)) : profileCount(type)
      ),
      ...deviceTypes.map(deviceCount),
      ...(showThirdParty ? [row.usage.thirdPartyDevices.totalCount] : []),
    ];
  });

  return [header, ...lines].map((cols) => cols.map(escapeCsv).join(',')).join('\n');
}
